import Vue from 'vue';
import { ActionContext } from 'vuex';

type GiftActionContext = ActionContext<CheeersGiftState, CheeersRootState>;

export default {
  namespaced: true,
  state: (): CheeersGiftState => ({
    categories: [],
    giftData: {
      categoryId: null,
      gift: null,
      message: null,
      staffToId: null,
    },
    thanksMessageDialog: false,
  }),
  getters: {
    categoryItems: (state: CheeersGiftState) =>
      state.categories.map((item) => ({
        text: item.name,
        value: item.id,
      })),
    thanksMessageDialog: (state: CheeersGiftState) => state.thanksMessageDialog,
    giftData: (state: CheeersGiftState) => state.giftData,

  },
  mutations: {
    setCategories(state: CheeersGiftState, categories: CheeersGiftCategory[]) {
      state.categories = categories;
    },
    setThanksMessageDialog(state: CheeersGiftState, value: boolean) {
      state.thanksMessageDialog = value;
    },
    setGiftData(state: CheeersGiftState, giftData) {
      state.giftData = giftData;
    },
  },
  actions: {
    async fetchCategories({ commit }: GiftActionContext) {
      const response = await Vue.prototype.$http.get(
        '/post-category?sort=id,DESC',
      );
      commit('setCategories', response.data);
    },
  },
};
